import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, element, ...rest }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  
  useEffect(() => {
    const checkAccess = async () => {
      // Don't do anything until the auth state is loaded
      if (loading) return;
      
      if (isAuthenticated === null) {
  return <div>Loading...</div>; // wait for auth to resolve
}
if (!isAuthenticated) {
        sessionStorage.setItem(
          'redirectAfterLogin', 
          `${location.pathname}${location.search}`
        );
        navigate('/login');
        return;
      }
      
      // Set access to true for now (implement actual checks as needed)
      setHasAccess(true);
      setCheckingAccess(false);
    };
    
    checkAccess();
  }, [isAuthenticated, loading, location, navigate, user]);
  
  if (loading || checkingAccess) {
    return <div>Loading...</div>;
  }
  
  if (!hasAccess) {
    return <Navigate to="/unauthorized" />;
  }
  
  // Return either children or element
  return children || element || null;
};

export default ProtectedRoute;
